(() => {
  const initialize = (root) => {
    if (root.dataset.pysInitialized === 'true') return;
    root.dataset.pysInitialized = 'true';
    const chips = Array.from(root.querySelectorAll('[data-pys-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-pys-product-card]'));
    const status = root.querySelector('[data-pys-filter-status]');
    const emptyState = root.querySelector('[data-pys-empty-state]');
    const filtersFor = (card) => (card.dataset.filters || '').split(/\s+/);
    chips.forEach((chip) => {
      chip.hidden = chip.dataset.pysFilter !== 'all' && !cards.some((card) => filtersFor(card).includes(chip.dataset.pysFilter));
    });
    const applyFilter = (requestedFilter) => {
      const filter = chips.some((chip) => !chip.hidden && chip.dataset.pysFilter === requestedFilter) ? requestedFilter : 'all';
      let visibleCount = 0;
      cards.forEach((card) => {
        card.hidden = filter !== 'all' && !filtersFor(card).includes(filter);
        if (!card.hidden) visibleCount += 1;
      });
      chips.forEach((chip) => {
        const active = chip.dataset.pysFilter === filter;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', String(active));
      });
      if (emptyState) emptyState.hidden = visibleCount !== 0;
      if (status) status.textContent = status.dataset.countMessage.replace('[count]', String(visibleCount));
    };
    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        const filter = chip.dataset.pysFilter;
        applyFilter(filter);
        const url = new URL(window.location.href);
        url.hash = filter === 'all' ? '' : 'filter=' + filter;
        window.history.replaceState(null, '', url);
      });
    });
    const applyLocationFilter = () => applyFilter(new URLSearchParams(window.location.hash.slice(1)).get('filter') || 'all');
    window.addEventListener('hashchange', applyLocationFilter);
    applyLocationFilter();
    root.querySelector('.pys-browser__filters').hidden = false;
  };
  document.querySelectorAll('[data-pys-digital-plans]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-pys-digital-plans]').forEach(initialize);
  });
})();
